import type { ReactNode } from 'react';
import { Alert, Spacer, Text } from '@ksyos/design-system';
import type { ProfessionalSummaryDataType } from '../../../../common/enums/professionalSummaryDataType';
import type { ProfessionalSummaryDataSectionLoadResult } from '../../../utils/professionalSummaryDataSectionLoadResult';
import { translateKey } from '../../../translate';
import { Loader } from '../../elements/common';
import { MedicationsCollapsible } from '../customControls/utils/v1/medications/MedicationsCollapsible';

export enum ProfessionalSummaryDataAction {
    add = 'add',
    pick = 'pick',
    skip = 'skip',
}

interface IProfessionalSummaryDataSectionProps {
    children?: ReactNode;
    extraHeaderElements?: JSX.Element;
    isOpen: boolean;
    loadResult?: ProfessionalSummaryDataSectionLoadResult;
    onToggle: () => void;
    professionalSummaryDataType: ProfessionalSummaryDataType;
    readOnly?: boolean;
    selectionCount: number;
}

export function ProfessionalSummaryDataSection(props: IProfessionalSummaryDataSectionProps) {
    return (
        <>
            <MedicationsCollapsible
                extraHeaderElements={props.extraHeaderElements}
                header={
                    props.readOnly
                        ? translateKey(`professionalSummary.${props.professionalSummaryDataType}Read`)
                        : translateKey(`professionalSummary.${props.professionalSummaryDataType}Add`)
                }
                isOpen={props.isOpen}
                onToggle={() => props.onToggle()}
                subHeader={
                    props.selectionCount || props.readOnly
                        ? translateKey('professionalSummary.selectionCount', props.selectionCount.toString())
                        : ''
                }
            >
                <>
                    {props.isOpen && props.loadResult && !props.loadResult.isLoadCompleted && (
                        <div className="layout center center-justified custom-loader">
                            <Spacer align="center">
                                <Loader large />
                                <Text
                                    as="p"
                                    size="sm"
                                >
                                    {translateKey('professionalSummary.loading')}
                                </Text>
                            </Spacer>
                        </div>
                    )}
                    {props.children}
                    {props.loadResult && props.loadResult.loadFailed && (
                        <Alert appearance="warning">
                            {translateKey(
                                'professionalSummary.loadError',
                                translateKey(`professionalSummary.${props.professionalSummaryDataType}`)
                            )}
                        </Alert>
                    )}
                </>
            </MedicationsCollapsible>
        </>
    );
}
